import { getFramework, IFramework } from '@/framework';
import { getStageGridStore } from './models/stage-grid-state';

export class StageGridPlugin {
    private framework: IFramework;
    constructor(id: string) {
        this.framework = getFramework(id);
    }

    showGridLineOperate(showGridLineOperate: boolean) {
        getStageGridStore(this.framework.identity).setShowGridLineOperate(showGridLineOperate);
    }
}
